// src/components/controller/ScheduleTimerModal.js
import { useState, useEffect } from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalButton
} from 'baseui/modal';
import { StatefulCalendar } from 'baseui/datepicker';
import { Input } from 'baseui/input';
import { Block } from 'baseui/block'; 
import { FormControl } from 'baseui/form-control';

/**
 * タイマー開始予約のためのモーダルコンポーネント
 */
const ScheduleTimerModal = ({ isOpen, onClose, onSchedule }) => {
  const { t } = useLocale();
  const [datePart, setDatePart] = useState(new Date());
  const [timeString, setTimeString] = useState('00:00');
  const [error, setError] = useState('');
  const [modalRenderKey, setModalRenderKey] = useState(0);

  const twoMonthsLater = new Date();
  twoMonthsLater.setMonth(twoMonthsLater.getMonth() + 2);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  useEffect(() => {
    if (isOpen) {
      const now = new Date();
      const initialTime = new Date(now.getTime() + 10 * 60000);
      const hours = String(initialTime.getHours()).padStart(2, '0');
      const minutes = String(initialTime.getMinutes()).padStart(2, '0');
      
      const initialDate = new Date(); 
      initialDate.setHours(0, 0, 0, 0);

      setDatePart(initialDate);
      setTimeString(`${hours}:${minutes}`);
      setError('');
      
      setModalRenderKey(prevKey => prevKey + 1);
    }
  }, [isOpen]);
  
  const handleDateChange = ({ date }) => {
    const newDate = Array.isArray(date) ? date[0] : date;
    if (newDate) {
      setDatePart(newDate);
    }
  };

  const handleSchedule = () => {
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    if (!timeRegex.test(timeString)) {
      setError(t('errors.invalidTimeFormat'));
      return;
    }
    
    const finalDate = new Date(datePart);
    const [hours, minutes] = timeString.split(':').map(Number);
    finalDate.setHours(hours, minutes, 0, 0);

    if (finalDate <= new Date()) {
      setError(t('common.errorInvalidDateTime'));
      return;
    }
    if (finalDate > twoMonthsLater) {
      setError(t('common.errorTooFarFuture'));
      return;
    }

    onSchedule(finalDate);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeable animate>
      <ModalHeader>{t('tournament.scheduleTimerTitle')}</ModalHeader>
      <ModalBody>
        <Block display="flex" justifyContent="center">
          <StatefulCalendar
            key={modalRenderKey}
            onChange={handleDateChange}
            initialState={{ value: datePart }}
            minDate={today}
            maxDate={twoMonthsLater}
            monthsShown={1}
          />
        </Block>
        
        <Block marginTop="scale600">
          <FormControl label={t('tournament.startTimeLabel')} error={error}>
            <Input
              type="time"
              value={timeString}
              onChange={e => setTimeString(e.target.value)}
              clearable
              size="large"
              overrides={{
                Input: { style: { fontSize: '1.5rem' } },
              }}
            />
          </FormControl>
        </Block>

      </ModalBody>
      <ModalFooter>
        <ModalButton kind="tertiary" onClick={onClose}>
          {t('common.modalCancel')}
        </ModalButton>
        <ModalButton onClick={handleSchedule}>
          {t('tournament.scheduleStartButton')}
        </ModalButton>
      </ModalFooter>
    </Modal>
  );
};

export default ScheduleTimerModal;